import { styled, SxProps, Theme, Typography } from '@mui/material';

const Base = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    userSelect: 'none',
    flexDirection: 'column',
});

interface Props {
    text: string;
    sx?: SxProps<Theme>;
    tryAgain?: boolean; // If true, shows a "Försök igen" link
}

export const NoRows = ({ text, sx, tryAgain }: Props) => {
    return (
        <Base sx={sx}>
            <Typography variant={'body2'} color='textSecondary'>
                <b>{text}</b>
            </Typography>
            {tryAgain && (
                <Typography
                    variant={'body2'}
                    color='textSecondary'
                    onClick={() => window.location.reload()}
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                    Klicka här för att ladda om sidan
                </Typography>
            )}
        </Base>
    );
};
